
import KitTemplatePage from 'components/distributionSetting/kitTemplate'
import CommonLayout from 'layouts/DashboardLayout'
import React from 'react'

const KitTemplate = () => {
    return (
        <CommonLayout>
            <KitTemplatePage />
        </CommonLayout>
    )
}

export default KitTemplate
